module.exports = __webpack_public_path__ + "3685765626d90c394fa8bed1c4bf38d9.svg";